import { render, staticRenderFns } from "./SearchBetgame.vue?vue&type=template&id=714cee17&scoped=true"
import script from "./SearchBetgame.vue?vue&type=script&lang=js"
export * from "./SearchBetgame.vue?vue&type=script&lang=js"
import style0 from "./SearchBetgame.vue?vue&type=style&index=0&id=714cee17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714cee17",
  null
  
)

export default component.exports